import { render } from "./GrupoDescList.vue?vue&type=template&id=43fee352&scoped=true"
import script from "./GrupoDescList.vue?vue&type=script&lang=js"
export * from "./GrupoDescList.vue?vue&type=script&lang=js"

import "./GrupoDescList.vue?vue&type=style&index=0&id=43fee352&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fee352"]])

export default __exports__